/** imported components

  * serviceProvider for ===> working with api
  * ChapterView ===> View file for chapter component
  * .scss ===> file for styling component

**/

import React, { useState, useEffect } from "react";
import { ChapterView } from "./chapter-view";
import "./chapter.scss";
import serviceProvider from '../../services/axios'

//Chapter component start
export const ChapterController = (props) => {
	const [results, setResults] = useState([]);
	const user = JSON.parse(localStorage.getItem("userData"));
	const usid = user ? user.uid : 0;
	const [onTab, setOnTab] = useState(0);
	useEffect(() => {
		const search = async () => {
			const getLastItem = (thePath) => thePath.substring(thePath.lastIndexOf("/") + 1);
			const cid = getLastItem(window.location.pathname);
			// id=${cid}
			const apiUrl = `/assessment?param=chapter&id=${cid}&uid=${usid}`;
			const { data } = await serviceProvider.get(apiUrl, true, {});
			setResults(data);
		};
		search();
	}, []);
	return <ChapterView sectionData={results} onTab={onTab} {...props} />;
};
